import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";
import { Globe2, Layers, Gauge, Truck, Sparkles } from "lucide-react";

const ICONS = [Globe2, Layers, Gauge, Truck, Sparkles];

export default function SourcingSection() {
  const { t } = useI18n();
  const cards = t("sourcing.cards");

  return (
    <section
      data-testid={TID.sourcing}
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="gc-eyebrow">{t("sourcing.eyebrow")}</p>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.02] tracking-tight font-[700] text-[color:var(--gc-ink)]">
              {t("sourcing.title")}
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg leading-relaxed text-[color:var(--gc-graphite)]">
              {t("sourcing.p1")}
            </p>
            <p className="mt-4 text-base leading-relaxed text-[color:var(--gc-steel)]">
              {t("sourcing.p2")}
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[color:var(--gc-line)] border border-[color:var(--gc-line)]">
          {Array.isArray(cards) &&
            cards.map((c, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.45, delay: i * 0.06 }}
                  className="bg-white p-7 min-h-[180px] flex flex-col justify-between group hover:bg-[color:var(--gc-paper)] transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <Icon className="w-6 h-6 text-[color:var(--gc-ink)]" strokeWidth={1.5} />
                    <span className="font-mono text-[10px] tracking-[0.2em] text-[color:var(--gc-mist)]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <p className="mt-12 text-[15px] font-medium leading-snug text-[color:var(--gc-ink)]">
                    {c}
                  </p>
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
